// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"50b844a3","386":"8c90b2c2","574":"58004b78"}[chunkId] + ".chunk.js";
};